import { render, staticRenderFns } from "./QuotesTable.vue?vue&type=template&id=34ffab62&scoped=true&"
import script from "./QuotesTable.vue?vue&type=script&lang=js&"
export * from "./QuotesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ffab62",
  null
  
)

export default component.exports